import { defineComponent as z, computed as f, openBlock as n, createBlock as a, resolveDynamicComponent as C, normalizeStyle as x, normalizeClass as b, withCtx as L, createCommentVNode as l, createElementBlock as r, createElementVNode as m, toDisplayString as p, renderSlot as _ } from "vue";
import c from "./index60.js";
const B = {
  key: 2,
  class: "relative flex flex-col items-center justify-center"
}, w = {
  key: 0,
  class: "btn-sub-text font-semibold"
}, $ = {
  key: 1,
  class: "button-spinner-overlay",
  "aria-hidden": "true"
}, j = /* @__PURE__ */ z({
  __name: "BaseButton",
  props: {
    variant: { default: "contained" },
    color: { default: "primary" },
    size: { default: "lg" },
    pill: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    leftIcon: {},
    rightIcon: {},
    centerIcon: { default: void 0 },
    label: { default: "" },
    subLabel: {},
    fullWidth: { type: Boolean, default: !1 },
    href: { default: void 0 },
    customClass: {},
    isLoading: { type: Boolean }
  },
  emits: ["click"],
  setup(y, { emit: h }) {
    const e = y, d = h, u = [
      "primary",
      "red",
      "blue",
      "green",
      "cancel",
      "grey",
      "white",
      "black",
      "yellow"
    ], g = f(() => !e.centerIcon && (e.label || e.subLabel)), v = f(() => {
      const t = [
        "inline-flex items-center justify-center gap-2.5",
        "transition-all duration-200",
        "select-none",
        "focus:outline-none",
        e.fullWidth ? "w-full" : "",
        `btn-variant-${e.variant}`,
        `btn-size-${e.size}`
      ];
      return e.disabled && t.push("btn-disabled"), e.pill && t.push("btn-pill"), e.variant !== "outline" && u.includes(e.color) && t.push(`btn-color-${e.color}`), e.customClass && t.push(e.customClass), e.variant === "chip" && t.push("!rounded-[3px] !px-2 !py-0.5 !h-5"), t;
    }), i = (t) => {
      switch (t) {
        case "lg":
        case "md":
          return "md";
        case "sm":
        case "mini":
          return "sm";
        default:
          return "md";
      }
    }, s = (t, o) => t?.color ? t.color : "currentColor";
    function I(t) {
      e.disabled || e.isLoading || d("click", t);
    }
    function k(t) {
      e.disabled || (t.key === " " || t.key === "Enter") && (t.preventDefault(), d("click", t));
    }
    return (t, o) => (n(), a(C(e.href ? "a" : "button"), {
      href: e.href,
      role: "button",
      type: e.href ? void 0 : "button",
      class: b([...v.value, "focus-ring"]),
      style: x(
        u.includes(e.color) ? {} : { "--button-custom-color": e.color }
      ),
      "aria-label": e.centerIcon ? e.centerIcon.name : e.label,
      "aria-disabled": e.disabled || e.isLoading ? "true" : void 0,
      tabindex: e.disabled || e.isLoading ? -1 : 0,
      disabled: !e.href && e.disabled,
      onClick: I,
      onKeydown: o[0] || (o[0] = (S) => e.href ? k : void 0)
    }, {
      default: L(() => [
        e.leftIcon && !e.centerIcon ? (n(), a(c, {
          key: 0,
          name: e.leftIcon.name,
          size: i(e.size),
          color: s(e.leftIcon, e.color)
        }, null, 8, ["name", "size", "color"])) : l("", !0),
        e.centerIcon ? (n(), a(c, {
          key: 1,
          name: e.centerIcon.name,
          size: i(e.size),
          color: s(e.centerIcon, e.color)
        }, null, 8, ["name", "size", "color"])) : l("", !0),
        g.value ? (n(), r("div", B, [
          m("span", {
            class: b([
              "font-medium",
              e.subLabel ? "btn-main-label" : "btn-label",
              e.variant === "chip" ? "!text-xs" : "",
              e.isLoading ? "opacity-0" : ""
            ])
          }, p(e.label), 3),
          e.subLabel && !e.isLoading ? (n(), r("span", w, p(e.subLabel), 1)) : l("", !0),
          e.isLoading ? (n(), r("span", $, [...o[1] || (o[1] = [
            m("span", { class: "button-spinner" }, null, -1)
          ])])) : l("", !0)
        ])) : l("", !0),
        e.rightIcon && !e.centerIcon ? (n(), a(c, {
          key: 3,
          name: e.rightIcon.name,
          size: i(e.size),
          color: s(e.rightIcon, e.color)
        }, null, 8, ["name", "size", "color"])) : l("", !0),
        _(t.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["href", "type", "class", "style", "aria-label", "aria-disabled", "tabindex", "disabled"]));
  }
});
export {
  j as default
};
